import { render, staticRenderFns } from "./4_inquiryPartnership.vue?vue&type=template&id=0dc1e157&"
import script from "./4_inquiryPartnership.vue?vue&type=script&lang=js&"
export * from "./4_inquiryPartnership.vue?vue&type=script&lang=js&"
import style0 from "./4_inquiryPartnership.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports